<template>
    <FullFillBox
        :pageID="1027"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.add === 1){
                this.showAddButton = true
            }
            if(data.edit === 1){
                this.showEditButton = true
            }
        }"
    >
        <h4>{{ $t('sys_role_manage') }}</h4>
        <hr>
        <div class="row g-2">
            <div class="col-md-8">
                <Multiselect
                    v-model="getRole"
                    :options="roleList"
                    mode="single"
                    :can-clear="true"
                    :searchable="true"
                    :placeholder="this.$t('sys_role_select') + ' (' + this.roleList.length + ')'"
                    @select="getRolePermissionDetail"
                    @clear="resetRolePermissionDetail"
                />
            </div>
            <div class="col-md-2">
                <button class="btn btn-primary"
                        v-if="showEditButton"
                        @click="addOrUpdateRoleName('update')">
                    {{ $t('sys_role_update') }}
                </button>
            </div>
            <div class="col-md-2">
                <button class="btn btn-primary"
                        v-if="showAddButton"
                        @click="addOrUpdateRoleName('add')">
                    {{ $t('sys_role_add') }}
                </button>
            </div>
        </div>
        <p class="error-text">* {{ $t('sys_role_admin_no_modify') }}</p>
        <hr>
        <div style="margin: 10px">
            <table class="table border" style="width: 100%;background-color: white" id="roleTable">
                <thead>
                <tr>
                    <th scope="col" style="width: 40%;">{{ $t('sys_page') }}</th>
                    <th scope="col" style="width: 12%;">{{ $t('sys_table_read') }}</th>
                    <th scope="col" style="width: 12%;">{{ $t('sys_table_add') }}</th>
                    <th scope="col" style="width: 12%;">{{ $t('sys_table_edit') }}</th>
                    <th scope="col" style="width: 12%;">{{ $t('sys_table_delete') }}</th>
                    <th scope="col" style="width: 12%;">{{ $t('sys_table_all') }}</th>
                </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
        <hr>
        <button class="btn-primary btn" @click="updateToServer">
            {{ $t('common_update') }}
        </button>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import Multiselect from "@vueform/multiselect";
export default {
    name: "SystemRoleManageView",
    components: {
        FullFillBox,
        Multiselect,
    },
    data(){
        return{
            permissionDetails: {},
            showAddButton: false,
            showEditButton: false,
            // default 2 as staff
            getRole: 2,
            roleList: [],
            roleDataList: [],

            idList: [],
            isAddNew: false,
        }
    },
    methods: {
        async updateToServer(){
            if(this.getRole){
                if(this.getRole !== 1){
                    let result = []
                    for(let i of this.idList){
                        let flag = document.getElementById(i).checked;
                        let res = {
                            "key": i,
                            "flag": flag
                        }
                        result.push(res)
                    }
                    let postData = {
                        "checkBoxDetail": result,
                        "id": this.getRole,
                    }
                    await this.$mainApi.post('api/client/role-details/', postData)
                        .then(response => {
                            if(response.data.status === 80){
                                this.$toast.success(this.$t('common_success'))
                                this.getBackendData()
                            }
                        })
                }else{
                    this.$swal.fire({
                        title: this.$t('sys_role_admin_no_modify'),
                        icon: 'warning',
                    })
                }
            }else{
                this.$swal.fire({
                    title: this.$t('sys_role_select_a_role_first'),
                    icon: 'warning',
                })
            }
        },
        async updateRoleList(){
            await this.$mainApi.get('api/client/role/')
                .then(response => {
                    if(response.data.status === 80){
                        this.roleList = []
                        this.roleDataList = response.data.details
                        for(let i=0;i<response.data.details.length;i++){
                            this.roleList.push({
                                "label": response.data.details[i]['roleName'],
                                "value": response.data.details[i]['id'],
                            })
                        }
                    }
                })
        },
        async getRolePermissionDetail(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get(`api/client/role-details?id=${this.getRole}`)
                .then(response => {
                    if(response.data.status === 80){
                        this.createRoleListTable(response.data.details)
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
        createRoleListTable(result){
            //clear
            this.idList = []

            // Clear Old Table
            let new_tbody = document.createElement('tbody');
            let tbodyRef = document.getElementById('roleTable').getElementsByTagName('tbody')[0];
            tbodyRef.parentNode.replaceChild(new_tbody, tbodyRef)

            let nowCatPk = null;
            for(let i=0;i<result.length;i++){
                // TR Header
                if(nowCatPk !== result[i]['catPk']){
                    let tbodyRef = document.getElementById('roleTable').getElementsByTagName('tbody')[0];
                    nowCatPk = result[i]['catPk']
                    // Not Same CatPK, New Cat, create a New TR
                    let htmlContent = "<tr><td colspan='6' style='background-color: #a6a6a6;font-size: 20px'>"+nowCatPk+"</td></tr>"
                    let newRowHeader = tbodyRef.insertRow(tbodyRef.rows.length);
                    newRowHeader.innerHTML = htmlContent;
                }

                // Main HTML content
                let container = "<tr>";

                // td 1: Page Name
                let pageName = result[i]['page']
                let pageID = result[i]['page_id']
                container = container + "<td>"+result[i]['page']+"</td>"

                // td 2-6: Check Box
                let allChecked = true
                let list = ['read', 'add', 'edit', 'delete']
                for(let q=0; q<list.length; q++){
                    let boxID = pageID + "_" + list[q]
                    if(result[i][list[q]] === -1){
                        // pass
                        container = container + "<td></td>"
                    }
                    if(result[i][list[q]] === 0){
                        this.idList.push(boxID)
                        allChecked = false
                        container = container +
                            "<td>" +
                            "<input onclick='checkBoxCheckRead(`"+boxID+"`)' type='checkbox' id='"+boxID+"' name='"+boxID+"' value='' style='width: 20px;height: 20px'>" +
                            "</td>"
                    }
                    if(result[i][list[q]] === 1){
                        this.idList.push(boxID)
                        container = container +
                            "<td>" +
                            "<input onclick='checkBoxCheckRead(`"+boxID+"`)' type='checkbox' id='"+boxID+"' name='"+boxID+"' value='' style='width: 20px;height: 20px' checked>" +
                            "</td>"
                    }
                }

                if(allChecked){
                    container = container +
                        "<td>" +
                        "<input onclick='checkBoxAllClick("+pageID+")' type='checkbox' id='"+pageID+"_all' name='"+pageID+"_all' value='' style='width: 20px;height: 20px' checked>" +
                        "</td>"
                }else{
                    container = container +
                        "<td>" +
                        "<input onclick='checkBoxAllClick("+pageID+")' type='checkbox' id='"+pageID+"_all' name='"+pageID+"_all' value='' style='width: 20px;height: 20px'>" +
                        "</td>"
                }

                let tbodyRef = document.getElementById('roleTable').getElementsByTagName('tbody')[0];
                let newRow = tbodyRef.insertRow(tbodyRef.rows.length);
                newRow.innerHTML = container + "</tr>";
            }
        },
        checkBoxCheckRead(getID){
            let is_checked = document.getElementById(getID).checked;
            if(is_checked){
                // If Checked, MUST check READ
                let res = getID.split('_');
                document.getElementById(res[0] + '_read').checked = true
            }
            if(!is_checked){
                // If NOT Checked, uncheck All
                let res = getID.split('_');
                document.getElementById(res[0] + '_all').checked = false
            }
        },
        checkBoxAllClick(getID){
            let is_checked = document.getElementById(getID+"_all").checked;
            let list = ['_read', '_add', '_edit', '_delete']
            if(is_checked){
                // Is True
                for(let a of list){
                    try{
                        document.getElementById(getID+a).checked = true;
                    }catch (Exception){
                        // pass
                    }
                }
            }else{
                for(let a of list){
                    try{
                        document.getElementById(getID+a).checked = false;
                    }catch (Exception){
                        // pass
                    }
                }
            }
        },
        addOrUpdateRoleName(flag){
            if(this.getRole){
                if(this.getRole === 1){
                    this.$swal.fire({
                        title: this.$t('sys_role_admin_no_modify'),
                        icon: 'warning',
                    })
                }else{
                    this.$swal.fire({
                        title: flag === 'add' ? this.$t('sys_role_add') : this.$t('sys_role_update'),
                        input: 'text',
                        inputValue: flag === 'add' ? '' :  this.roleDataList.find(e => e.id === this.getRole).roleName,
                        icon: 'info',
                        inputValidator: (inputValue) => {
                            return new Promise((resolve) => {
                                if (inputValue) {
                                    resolve()
                                } else {
                                    resolve(this.$t('sys_role_name_required'))
                                }
                            })
                        },showCancelButton: true,
                        confirmButtonText: flag === 'add' ? this.$t('common_add') : this.$t('common_update'),
                        showLoaderOnConfirm: true,
                        preConfirm: (getName) => {
                            return this.$mainApi.post(`api/client/role/`, {
                                "id": flag === "add" ? 0 : this.getRole,
                                "roleName": getName,
                            })
                                .then(response => {
                                    return response.data
                                })
                                .catch(error => {
                                    this.$swal.showValidationMessage(
                                        `Request failed: ${error}`
                                    )
                                })
                        },
                        allowOutsideClick: () => !this.$swal.isLoading()
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if(result.value.status === 80){
                                this.$swal.fire({
                                    title: this.$t('common_success'),
                                    icon: 'success'
                                })
                                this.getRole = result.value.details
                                this.getBackendData()
                            }else{
                                this.$swal.fire({
                                    title: result.value.errors,
                                    text: JSON.stringify(result.value.details),
                                    icon: 'error'
                                })
                            }
                        }
                    })
                    this.isAddNew = false
                }
            }else{
                this.$swal.fire({
                    title: this.$t('sys_role_select_a_role_first'),
                    icon: 'warning',
                })
            }
        },
        resetRolePermissionDetail(){
            //clear
            this.idList = []

            // Clear Old Table
            let new_tbody = document.createElement('tbody');
            let tbodyRef = document.getElementById('roleTable').getElementsByTagName('tbody')[0];
            tbodyRef.parentNode.replaceChild(new_tbody, tbodyRef)
        },
        getBackendData(){
            this.updateRoleList()
            this.getRolePermissionDetail()
        }
    },
    mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('sys_role_manage')
        this.getBackendData()
    },
    created(){
        window.checkBoxAllClick = this.checkBoxAllClick;
        window.checkBoxCheckRead = this.checkBoxCheckRead;
    }
}
</script>

<style scoped>

</style>
